import React from 'react';
import { css } from '@compiled/react';
import { Button, ButtonAppearance, Divider, Eyebrow } from '@atlassian/learning-components';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';

interface DateHeaderProps {
  displayText: string;
  showClearButton?: boolean;
  hideClearOnDesktop?: boolean;
  onClearClick?: () => void;
}

export const DateHeader: React.FC<DateHeaderProps> = ({
  displayText,
  showClearButton = false,
  hideClearOnDesktop = true,
  onClearClick,
}) => {
  return (
    <div css={calendarMonthHeaderStyles}>
      <div css={[selectedDateHeaderStyles, hideClearOnDesktop && selectedDateHeaderStylesDesktop]}>
        <Eyebrow size="medium" fontWeight="semibold">
          {displayText}
        </Eyebrow>
        {showClearButton && (
          <Button
            data-testid="clear-selected-date-button"
            label="Clear"
            appearance={ButtonAppearance.LINK}
            onClick={onClearClick}
          />
        )}
      </div>

      <div css={calendarHeaderDividerStyles}>
        <Divider color={token('color.border')} />
      </div>
    </div>
  );
};

const calendarMonthHeaderStyles = css({
  [media.below.md]: {
    padding: `${token('space.300')} ${token('space.200')} ${token('space.200')} ${token('space.200')}`,
    backgroundColor: '#F8F8F8',

    '& div:last-of-type': {
      display: 'none',
    },
  },
});

const calendarHeaderDividerStyles = css({
  marginTop: token('space.200'),
  marginBottom: token('space.200'),
});

const selectedDateHeaderStyles = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const selectedDateHeaderStylesDesktop = css({
  '& button': {
    [media.above.md]: {
      display: 'none',
    },
  },
});
